import { FC } from 'react';
import { useBoolean } from 'react-easyrocket';
import { useTranslation } from 'react-i18next';
import { Arrow } from '../svg/Arrow';
import classNames from 'classnames';
import { CategoryItem } from './CategoryItem';
import { GameCategoriesParams } from 'src/constants/gameCategories';

interface CategoryDropdownProps {
  openedByDefault?: boolean;
  title: string;
  options: GameCategoriesParams[];
}

export const CategoryDropdown: FC<CategoryDropdownProps> = ({
  openedByDefault = false,
  title,
  options
}) => {
  const [opened, , , toggle] = useBoolean(openedByDefault);
  const { t } = useTranslation();

  return (
    <div className="w-full flex flex-col justify-center items-center gap-2">
      <div
        className="w-full flex justify-between items-center cursor-pointer px-2 py-1"
        onClick={toggle}>
        <p className="text-sgc_category_title text-base font-medium">{t(title)}</p>
        <div className={classNames(!opened && 'rotate-180', 'transition-all duration-200')}>
          <Arrow />
        </div>
      </div>
      {opened && (
        <div className="w-full flex flex-col justify-center items-center gap-1">
          {options.map((option) => (
            <CategoryItem option={option} key={option.title} />
          ))}
        </div>
      )}
    </div>
  );
};
